import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Lock, Mail, ArrowRight, Eye, EyeOff } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AdminLogin = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPw, setShowPw] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const res = await axios.post(`${API}/admin/login`, { email, password });
      localStorage.setItem("fs_admin_token", res.data.token);
      localStorage.setItem("fs_admin_email", res.data.email);
      navigate("/dashboard");
    } catch (err) {
      setError(
        err?.response?.status === 401
          ? "Credenziali non valide. Riprova."
          : "Errore di connessione. Riprova."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-auth">
      <div className="admin-auth-card">
        <p className="logo-mark header-logo" style={{ marginBottom: 6 }}>
          <span className="l1">Francesca</span>
          <span className="l2">Spinazzola</span>
        </p>
        <p className="admin-auth-eyebrow">Area riservata</p>
        <h1 className="admin-auth-title serif">Accedi alla dashboard</h1>

        <form onSubmit={submit} className="admin-form">
          <label className="admin-field">
            <Mail size={17} strokeWidth={1.6} />
            <input
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </label>
          <label className="admin-field">
            <Lock size={17} strokeWidth={1.6} />
            <input
              type={showPw ? "text" : "password"}
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <button
              type="button"
              className="pw-toggle"
              onClick={() => setShowPw((v) => !v)}
              aria-label={showPw ? "Nascondi password" : "Mostra password"}
            >
              {showPw ? <EyeOff size={17} strokeWidth={1.6} /> : <Eye size={17} strokeWidth={1.6} />}
            </button>
          </label>

          {error && <p className="admin-error">{error}</p>}

          <button type="submit" className="admin-submit" disabled={loading}>
            <span>{loading ? "Accesso..." : "Entra"}</span>
            <ArrowRight size={17} strokeWidth={1.8} />
          </button>
        </form>

        <a href="/" className="admin-back-home">
          &larr; Torna al sito
        </a>
      </div>
    </div>
  );
};

export default AdminLogin;
